import { render, staticRenderFns } from "./ConceptsImageSizes.vue?vue&type=template&id=3126d227"
import script from "./ConceptsImageSizes.vue?vue&type=script&lang=ts"
export * from "./ConceptsImageSizes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports